import { render, staticRenderFns } from "./DImage.vue?vue&type=template&id=1a306c7b&scoped=true&"
import script from "./DImage.vue?vue&type=script&lang=js&"
export * from "./DImage.vue?vue&type=script&lang=js&"
import style0 from "./DImage.vue?vue&type=style&index=0&id=1a306c7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a306c7b",
  null
  
)

export default component.exports